<template>
  <Modal :style="computedWindowSize"
         :visible="visible"
         class="p-fluid"
         @close="close">
    <template v-slot:header>
      <div class="p-dialog-title">
        {{ item?.id ? $t('serviceEditModalTitle') : $t('serviceCreateModalTitle') }}
      </div>
    </template>

    <Spinner v-if="dataIsSending"/>

    <div v-else>
      <div class="p-formgrid p-grid p-pt-3">
        <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-5">
          <div class="p-float-label">
            <CustomDropdown id="service_category_modal"
                            v-model="selectedCategory"
                            :options="categories"
                            :clearSearchData="!visible"
                            optionLabel="name"
                            :filter="true"
                            :showClear="true">
              <template #value="slotProps">
                <div v-if="slotProps.value">
                  <span>{{ slotProps.value.name }}</span>
                </div>
                <span v-else style="visibility: hidden">.</span>
              </template>
              <template #option="slotProps">
                <div>
                  <span>{{ slotProps.option.name }}</span>
                </div>
              </template>
            </CustomDropdown>
            <label for="service_category_modal">{{ $t('Category') }}</label>
          </div>
        </div>
        <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-5">
          <div class="p-float-label">
            <InputText id="service_code_modal" v-model.trim="itemData.code" autocomplete="off"/>
            <label for="service_code_modal">{{ $t('Code') }}</label>
          </div>
        </div>
        <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-5">
          <div class="p-float-label">
            <InputText id="service_name_modal" :class="{'p-invalid' : submitted && !itemData.name}" v-model.trim="itemData.name" autocomplete="off"/>
            <label for="service_name_modal">{{ $t('Name') }}<span class="warning-color">*</span></label>
          </div>
          <small class="p-invalid" v-if="submitted && !itemData.name">{{ $t('Required field') }}</small>
        </div>

        <div class="p-field p-col-12 p-sm-6 p-md-6 p-lg-6 p-mb-5">
          <div class="p-float-label">
            <InputNumber :locale="computedNumberInputLocale"
                         id="purchase-price-service-modal"
                         v-model="itemData.purchase"
                         mode="decimal"
                         :min="0"
                         :minFractionDigits="2"
                         :maxFractionDigits="4"
                         autocomplete="off"/>
            <label for="purchase-price-service-modal">{{ $t('Purchase price') }}</label>
          </div>
        </div>

        <div class="p-field p-col-12 p-sm-6 p-md-6 p-lg-6 p-mb-5">
          <div class="p-float-label">
            <InputNumber :locale="computedNumberInputLocale"
                         id="sell-price-service-modal"
                         :class="{'p-invalid' : submitted && !itemData.sell}"
                         v-model="itemData.sell"
                         mode="decimal"
                         :min="0"
                         :minFractionDigits="2"
                         :maxFractionDigits="4"
                         autocomplete="off"/>
            <label for="sell-price-service-modal">{{ $t('Selling price') }}<span class="warning-color">*</span></label>
          </div>
          <small class="p-invalid" v-if="submitted && !itemData.sell">{{ $t('Required field') }}</small>
        </div>

        <div class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-5" style="margin-top: -22px">
          <div class="p-text-secondary p-d-flex p-ai-center">
            <i class="ti-info-alt p-mr-1"/>
            <small>{{ $t('pricesExcludingVatLabel') }}</small>
          </div>
        </div>
<!--        <div v-if="canUseConsumables" class="p-field p-col-12 p-sm-6 p-md-6 p-lg-6">-->
<!--          <div class="p-float-label">-->
<!--            <InputNumber :locale="computedNumberInputLocale"-->
<!--                         id="service_consumables_sell_modal"-->
<!--                         v-model="itemData.consumables_sell"-->
<!--                         :min="0"-->
<!--                         :minFractionDigits="2"-->
<!--                         :maxFractionDigits="3"-->
<!--                         autocomplete="off"/>-->
<!--            <label for="service_consumables_sell_modal">{{ $t('consumablesSellingPriceLabel') }}</label>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="p-field p-col-12 p-sm-6 p-md-6 p-lg-6">-->
<!--          <div class="p-float-label">-->
<!--            <InputNumber :locale="computedNumberInputLocale"-->
<!--                         id="service_consumables_sell_modal"-->
<!--                         v-model="itemData.consumables_sell"-->
<!--                         :disabled="!canUseConsumables"-->
<!--                         :min="0"-->
<!--                         :minFractionDigits="2"-->
<!--                         :maxFractionDigits="3"-->
<!--                         autocomplete="off"/>-->
<!--            <label for="service_consumables_sell_modal">-->
<!--              {{ $t('consumablesSellingPriceLabel') }}-->
<!--            </label>-->
<!--          </div>-->
<!--          <BillingFeatureHint v-if="!canUseConsumables"-->
<!--                              feature="consumables"-->
<!--                              message-key="billing.features.consumables.availableFromBasicHint"-->
<!--                              class="p-d-block p-mt-2"/>-->
<!--        </div>-->


        <div class="p-field p-col-12 p-sm-6 p-md-6 p-lg-6 p-mb-0">
          <div class="p-float-label">
            <InputNumber :locale="computedNumberInputLocale"
                         id="service_consumables_sell_modal"
                         v-model="itemData.consumables_sell"
                         :disabled="!canUseConsumables"
                         :min="0"
                         :minFractionDigits="2"
                         :maxFractionDigits="3"
                         autocomplete="off"/>
            <label for="service_consumables_sell_modal">{{ $t('consumablesSellingPriceLabel') }}</label>
          </div>
        </div>

        <div v-if="!canUseConsumables" class="p-col-12 p-mt-1">
          <BillingFeatureHint feature="consumables"
                              message-key="billing.features.consumables.availableFromBasicHint"
                              class="p-d-block"/>
        </div>
      </div>

<!--      <div class="section-divider p-mt-3" :class="{ 'section-divider&#45;&#45;without-consumables': !canUseConsumables }">-->
      <div class="section-divider p-mt-4">
        <div class="p-d-flex p-ai-center p-text-secondary">
          <i class="ti-time p-mr-1"/>
          <div>{{ $t('Duration') }}</div>
        </div>
        <hr class="section-divider__hr">
      </div>

      <div class="p-formgrid p-grid p-pt-1">
        <div class="p-field p-col-12 p-sm-6 p-md-6 p-lg-6 p-mt-3">
          <div class="p-inputgroup">
            <InputNumber
                :locale="computedNumberInputLocale"
                id="service_time_hours_modal"
                v-model="serviceTimeHours"
                mode="decimal"
                :min="0"
                :max="999"
                :minFractionDigits="0"
                :maxFractionDigits="0"
                autocomplete="off"/>
            <span class="p-inputgroup-addon">{{ $t('h') }}</span>
          </div>
        </div>

        <div class="p-field p-col-12 p-sm-6 p-md-6 p-lg-6 p-mt-3">
          <div class="p-inputgroup">
            <InputNumber
                :locale="computedNumberInputLocale"
                id="service_time_minutes_modal"
                v-model="serviceTimeMinutes"
                mode="decimal"
                :min="0"
                :max="59"
                :minFractionDigits="0"
                :maxFractionDigits="0"
                autocomplete="off"/>
            <span class="p-inputgroup-addon">{{ $t('m') }}</span>
          </div>
        </div>
      </div>
    </div>


    <template #footer>
      <Button :label="$t('Cancel')" icon="pi pi-times" class="p-button-text" @click="close"/>
      <Button :label="$t('Save')"
              :disabled="dataIsSending || disableSaveButton"
              :loading="dataIsSending"
              icon="pi pi-check"
              class="p-button-text"
              @click="saveItem"/>
    </template>
  </Modal>

  <ItemExistsModal :visible="itemExistsModal"
                   :itemId="itemData?.id ? +itemData.id : null"
                   type="service"
                   :items="foundItems"
                   @select-existing="selectExistingItem"
                   @close="closeItemExistsModal"/>
</template>

<script>
import httpClient from '@/services/http.services'
import formatMixins from "@/mixins/formatMixins";
import settings from "@/settings";
import showErrorsMixins from "@/mixins/showErrorsMixins";
import ItemExistsModal from "@/components/ItemExistsModal.vue";
import foundModalItemsMixin from "@/mixins/foundModalItemsMixin";
import billingFeaturesMixins from '@/mixins/billingFeaturesMixins'
import BillingFeatureHint from "@/components/billing/BillingFeatureHint.vue";

export default {
  mixins: [ showErrorsMixins, formatMixins, foundModalItemsMixin, billingFeaturesMixins ],
  components: { ItemExistsModal, BillingFeatureHint },
  emits: ['close', 'update-items'],
  name: 'ServiceModal',
  props: {
    item: {
      type: Object,
      default: null
    },
    categories: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    },
    modalLayer: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      dataIsSending: false,
      disableSaveButton: false,
      selectedCategory: null,
      itemData: {},
      // serviceTimeMinutes: null,
      serviceTimeHours: null,
      serviceTimeMinutes: null,
      submitted: false
    }
  },
  watch: {
    item(value) {
      this.createItemData(value)
    },
    visible() {
      if (!this.visible) {
        this.disableSaveButton = false
        this.dataIsSending = false
        this.submitted = false
        this.selectedCategory = null
      }
    },
  },
  methods: {
    createItemData(value = null) {
      if (!value) {
        this.itemData = {}
        this.selectedCategory = null
        // this.serviceTimeMinutes = null
        this.serviceTimeHours = null
        this.serviceTimeMinutes = null
        return
      }

      this.itemData = { ...value }

      // this.itemData.time = value.time ? +value.time : null
      // this.serviceTimeMinutes = value.id ? this.hoursToMinutes(value.time) : null

      const totalMinutes = value.id ? this.hoursToMinutes(value.time) : null

      if (totalMinutes !== null) {
        this.serviceTimeHours = Math.floor(totalMinutes / 60)
        this.serviceTimeMinutes = totalMinutes % 60
      } else {
        this.serviceTimeHours = null
        this.serviceTimeMinutes = null
      }

      this.itemData.is_recurring = value.is_recurring ? true : false
      this.itemData.purchase =  value.purchase ? +value.purchase : null
      this.itemData.sell = value.sell ? +value.sell : null
      this.itemData.consumables_sell = value.consumables_sell ? +value.consumables_sell : null


      this.selectedCategory = null

      if (value.service_category_id) {
        const selectedCategory = this.categories?.find(
            category => Number(category.id) === Number(value.service_category_id)
        )

        if (selectedCategory) {
          this.selectedCategory = selectedCategory
        }
      }
    },
    async saveItem() {
      this.submitted = true
      if (!this.itemData.name || !this.itemData.sell) {
        return false
      }

      this.disableSaveButton = true
      this.dataIsSending = true

      const serviceTimeTotalMinutes = this.serviceTimeTotalMinutes()

      const service = {
        id: this.itemData.id ?? null,
        code: this.itemData.code ?? null,
        name: this.itemData.name ?? null,
        service_category_id: this.selectedCategory?.id ?? null,
        // time: this.serviceTimeMinutes || this.serviceTimeMinutes === 0
        //     ? this.minutesToHours(this.serviceTimeMinutes)
        //     : null,
        time: serviceTimeTotalMinutes !== null
            ? this.minutesToHours(serviceTimeTotalMinutes)
            : null,
        purchase: this.itemData.purchase ? this.itemData.purchase : null,
        sell: this.itemData.sell ? this.itemData.sell : null,
        use_consumables: this.itemData.consumables_sell ? 1 : 0,
        consumables_sell: this.itemData.consumables_sell ? this.itemData.consumables_sell : null,
        is_recurring: this.itemData.is_recurring ? 1 : 0,
        mileage_step: this.itemData.mileage_step ? this.itemData.mileage_step : null,
        time_step: this.itemData.time_step ? this.itemData.time_step : null,
      }

      if (this.itemData.id) {
        this.itemData.isNew = false
        try {
          const { status, data } = await httpClient.post(`service/update`, service)
          if (status === 200 && data?.success) {
            this.$emit('update-items', this.itemData.id)
            // this.$emit('update-item', this.itemData)
            this.$toast.add({severity: 'success', detail: this.$t('Data updated'), life: settings.toastLife});
            this.close()
          } else if (data?.found_items) {
            this.foundItems = data.found_items
            this.openItemExistsModal()
          } else if (data?.error) {
            this.$toast.add({severity:'error', summary: data.error.summary, detail: data.error.detail, life: settings.toastLife});
          } else {
            this.showUnknownError()
          }
        } catch(err) {
          this.showError(err)
        } finally {
          this.dataIsSending = false
          this.disableSaveButton = false
        }
      } else {
        try {
          const { status, data } = await httpClient.post(`service/create`, service)
          if (status === 201 && data?.success) {
            service.id = data.id
            this.itemData.id = data.id
            this.itemData.isNew = true
            this.$emit('update-items', this.itemData.id)
            // this.$emit('update-item', this.itemData)
            this.$toast.add({severity:'success', detail: this.$t('Data saved'), life: settings.toastLife});
            this.close()
          } else if (data?.found_items) {
            this.foundItems = data.found_items
            this.openItemExistsModal()
          } else if (data?.error) {
            this.$toast.add({severity:'error', summary: data.error.summary, detail: data.error.detail, life: settings.toastLife});
          } else {
            this.showUnknownError()
          }
        } catch(err) {
          this.showError(err)
        } finally {
          this.dataIsSending = false
          this.disableSaveButton = false
        }
      }
    },
    serviceTimeTotalMinutes() {
      const hoursIsSet = this.serviceTimeHours !== null && this.serviceTimeHours !== undefined
      const minutesIsSet = this.serviceTimeMinutes !== null && this.serviceTimeMinutes !== undefined

      if (!hoursIsSet && !minutesIsSet) return null

      const hours = Number(this.serviceTimeHours || 0)
      const minutes = Number(this.serviceTimeMinutes || 0)

      return hours * 60 + minutes
    },
    hoursToMinutes(value) {
      const hours = Number(value || 0)
      return hours > 0 ? Math.round(hours * 60) : null
    },

    minutesToHours(value) {
      const minutes = Number(value || 0)
      return minutes > 0 ? minutes / 60 : 0
    },
    close() {
      this.$emit('close')
      this.submitted = false
    },
  },
  computed: {
    computedWindowSize() {
      if (this.$store.state.mobileLayout) {
        return {position: 'absolute', top: 0, width: '95%', maxWidth: '440px', marginTop: '10px'}
      } else if (!this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {position: 'absolute', top: 0, width: '440px', marginTop: '15px'}
      } else {
        return {position: 'absolute', top: 0, width: '440px'}
      }
    },
  },

}
</script>
<style scoped lang="scss">
td {
  height: 44px
}

//.section-divider--without-consumables {
//  margin-top: 0 !important;
//}
.section-divider {
  display: flex;
  align-items: center;
  //gap: 8px;
}

.section-divider__hr {
  flex: 1;
  //border: none;
  //border-top: 1px solid #e5e7eb;
  margin: 0 0 0 12px;
}


</style>